// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectLightSensorDelay_root__2Abh4","sensorReadingsText":"SelectLightSensorDelay_sensorReadingsText__2JPNO"};